import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const FlameIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 25"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M10 6.41229C7.60001 7.21229 6.66668 11.079 6.50001 12.9123L3.99994 10.9123L3.50001 14.4123C2.30001 21.2123 8.66668 23.2456 12 23.4123C17.6 24.6123 20.3333 19.9123 21 17.4123C22.2 14.2123 19.8333 10.7456 18.5 9.41229C19.3 12.2123 16.8333 13.2456 15.5 13.4123C18.3 8.61229 13.6667 3.41229 11 1.41229C12.2 3.01229 10.8333 5.41229 10 6.41229Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9 3.19618C11.9623 3.67047 11.9632 4.10716 11.9114 4.50917C11.7748 5.56753 11.2816 6.30926 10.7296 6.79631L10.6848 6.83583L10.6349 6.8687C8.04407 8.57596 7.48396 11.5944 7.34394 13.046C7.29677 13.535 6.87701 13.9223 6.36329 13.9009C5.44576 13.8627 4.80584 13.3453 4.39471 12.7754C4.07325 14.3585 4.21005 15.8913 4.37671 16.6301L4.37772 16.6345L4.37771 16.6345C4.7331 18.2504 5.53978 19.5151 6.54198 20.4978C9.54037 23.4378 14.7201 23.622 17.9643 20.9337C19.4006 19.7434 20.0922 18.4464 20.227 17.712L20.233 17.6796L20.2414 17.6478C20.6415 16.1371 20.4094 14.5817 19.9106 13.1773C19.7203 12.6415 19.4941 12.1361 19.2571 11.6746C19.0162 12.2913 18.6402 12.8064 18.2034 13.2177C17.3289 14.0413 16.201 14.4636 15.4103 14.5194C15.0148 14.5473 14.6874 14.3306 14.5257 14.0418C14.3712 13.7657 14.36 13.4188 14.5205 13.1229C15.7921 10.7782 15.4238 8.46292 14.3306 6.40469C13.6882 5.19537 12.8062 4.10142 11.9 3.19618ZM9.79901 0.235459C10.0868 -0.0161561 10.57 -0.111564 10.9748 0.179001C12.5444 1.30589 14.5691 3.22978 15.8319 5.60724C16.8657 7.55358 17.4084 9.85373 16.7131 12.2467C16.8246 12.1668 16.9338 12.0781 17.0379 11.9802C17.588 11.462 17.9841 10.7001 17.7892 9.57222C17.7038 9.07759 18.0028 8.69891 18.3161 8.5454C18.6406 8.38643 19.1749 8.3853 19.5031 8.83721C20.1051 9.66612 20.9433 11.0055 21.5126 12.6084C22.0782 14.2011 22.3982 16.1116 21.8928 18.0524C21.6546 19.2839 20.6804 20.8907 19.049 22.2427C15.1449 25.4778 8.98206 25.2713 5.35177 21.7117C4.14787 20.5312 3.15394 18.9824 2.71787 17.0019C2.43734 15.7559 2.21431 12.7653 3.47818 10.1974C3.69214 9.7627 4.14173 9.62021 4.49579 9.68287C4.84205 9.74416 5.19538 10.0149 5.27212 10.4624C5.34252 10.8729 5.49175 11.3498 5.72231 11.706C5.7476 11.745 5.77297 11.7815 5.79847 11.8154C6.12226 10.0151 7.01979 7.24574 9.64377 5.48624C9.90406 5.2432 10.1504 4.87263 10.2254 4.29162C10.3063 3.66416 10.1958 2.72056 9.56191 1.35384C9.36303 0.925013 9.51746 0.481609 9.79901 0.235459Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default FlameIconFilled;
